import { render, staticRenderFns } from "./CalendarPermissionsTable.vue?vue&type=template&id=5c66a096&"
import script from "./CalendarPermissionsTable.vue?vue&type=script&lang=js&"
export * from "./CalendarPermissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports